export const iconSizes = ['xs', 's', 'm'] as const;
export type IconSize = typeof iconSizes[number];
